<template>
  <div>
    <alert-error :error="error"></alert-error>

    <v-text-field
      v-for="language in languages"
      :key="language.id"
      v-model="localItem[language.locale]"
      :rules="rules.requiredTextLine"
      :label="`${language.name} *`"
    ></v-text-field>
  </div>
</template>

<script>
import { requiredTextLine } from '@/modules/_global/variables/rules.js';

export default {
  name: 'TagForm',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  model: {
    prop: 'itemOutside',
    event: 'input'
  },

  props: {
    itemOutside: {
      type: Object,
      required: true
    },
    languages: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    localItem: null,
    error: null,
    rules: {
      requiredTextLine
    }
  }),

  watch: {
    localItem: {
      deep: true,
      handler: 'updateItemOutside'
    }
  },

  created() {
    this.localItem = Object.assign({}, this.itemOutside);
  },

  methods: {
    updateItemOutside() {
      this.$emit('input', this.localItem);
    }
  }
};
</script>
